// @flow
import React, { useRef, useState, useEffect } from 'react';
import { connect } from 'react-redux';
import {
  Input,
  Modal,
} from 'antd';
import SimpleReactValidator from 'simple-react-validator';
import { SpH5, SpError, SpButton } from 'components/DesignKit';

type Props = {
  close: Function,
  submit: Function,
  visible: boolean,
  submitting: boolean,
  selectedPosKey: Object,
};

const EditPosKey = (props: Props) => {
  const {
    visible,
    close,
    submit,
    submitting,
    selectedPosKey,
  } = props;

  const [, forceUpdate] = useState();
  const gid = selectedPosKey ? selectedPosKey.gid : '';
  const [apiKey, setApiKey] = useState(selectedPosKey ? selectedPosKey.apiKey : '');
  const [disableButton, setDisableButton] = useState(false);
  const simpleValidator = useRef(new SimpleReactValidator());

  useEffect(() => {
    if (!submitting) {
      setDisableButton(false);
    }
  }, [submitting]);


  const validate = (event) => {
    setDisableButton(true);
    event.preventDefault();
    const formValid = simpleValidator.current.allValid();
    setDisableButton(formValid);
    if (!formValid) {
      simpleValidator.current.showMessages();
      forceUpdate(1);
      return;
    }
    submit({
      gid,
      apiKey,
    });
  };

  return (
    <Modal
      centered
      closable={false}
      visible={visible}
      footer={[
        <SpButton onClick={() => close()} type="secondary">Cancel</SpButton>,
        <SpButton onClick={validate} disabled={disableButton}>Update</SpButton>,
      ]}
      title="Update POS Key"
    >
      <div className="px-4">
        <div className={submitting ? 'OVERLAY' : ''} />
        <div className="mb-3">
          <label htmlFor=""><SpH5>GID</SpH5></label>
          <Input
            placeholder="GID"
            value={gid}
            disabled
          />
        </div>
        <div>
          <label htmlFor=""><SpH5>API Key</SpH5></label>
          <Input
            placeholder="API Key"
            value={apiKey}
            onChange={(e) => setApiKey(e.currentTarget.value)}
          />
          <SpError>
            {simpleValidator.current.message('api key', apiKey, 'required')}
          </SpError>
        </div>
      </div>
    </Modal>
  );
};

const mapStateToProps = (state) => ({
  validator: state.loading.validator,
  submitting: state.loading.submitting,
  test: state.account.test,
});

// $FlowFixMe
export default connect(mapStateToProps, null)(EditPosKey);
